exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.svg-we-light path[data-v-5b144dc7] {\n  fill: #367C2C;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/vue-svg-inline-loader/dist/index.min.js!./resources/js/Components/new/UsedCard.vue?vue&type=style&index=0&id=5b144dc7&scoped=true&lang=css
// module id = 95
// module chunks = 0 4 6 7 8 10 11 13